export const handleNumberChange = (e, currentValue, handleChange, allowDecimal = false) => {
  const re = allowDecimal ? /^([0-9]+\.?[0-9]*|\.[0-9]+)$/ : /^[0-9\b]+$/;

  if (e.target.value === '' || re.test(e.target.value)) {
    handleChange(e);
  } else {
    e.target.value = currentValue ?? '';
  }
};
